var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({directives:[{name:"show-fade",rawName:"v-show-fade",value:({ isFilter: _vm.isFilter }),expression:"{ isFilter: isFilter }"}],class:[_vm.selectMixinClass],attrs:{"value":_vm.value,"hide-details":"","clearable":_vm.clearable,"autocomplete":"off","outlined":""},on:{"input":value => {
      _vm.$emit('input', value);
    }}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }